import { useCallback, useEffect } from 'react';
import debounce from 'lodash/debounce';
import { useEventCallback } from '../useEventCallback';
/**
 * provide a debounce method for debounce method
 * @param fn method for debounce
 * @param debounceTime debounce timeout value, default is  `200`ms
 * @param debounceSettings debounce setting object, more detail see `lodash`
 */
export var useDebounce = function (fn, debounceTime, debounceSettings) {
    if (debounceTime === void 0) { debounceTime = 200; }
    var memoFn = useEventCallback(fn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var debounceFn = useCallback(debounce(memoFn, debounceTime, debounceSettings), []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(function () { return function () { return debounceFn.cancel(); }; }, []);
    return debounceFn;
};
